{
  "intro": "This creates the first administrator of this installation. It works once.",
  "submit": "Create administrator",
  "title": "Set up the first administrator",
  "token": "Setup token",
  "tokenHint": "The value of accounts.first_administrator_setup_token in the server's configuration."
}
